import styled from '@emotion/styled';

export const Title = styled.div`
  ${({theme}) => theme.typography.headlineSmall}
  text-align: center;
  margin: 0 auto;
  padding-left: 32px;
`;
